function DashboardMonthData({ filterData }) {
  if (!filterData) {
    return null; // Return nothing or a placeholder if the data is missing
  }

  return (
    <>
      <div className="grid xl:grid-cols-1 gap-2 mb-2">
        <div className="flex flex-col items-center p-4 w-auto">
          {/* Months Row */}
          <div className="flex justify-between w-auto border-b border-gray-300 pb-2 gap-10">
            {filterData &&
              filterData.Months &&
              filterData.Months.length > 0 &&
              filterData.Months.map((month, index) => (
                <div key={`month-${index}`} className="flex-2 text-center w-auto text-gray-500 text-sm font-bold">
                  {month === 6 ? 'Last 6 Months' : month === 3 ? 'Last 3 Months' : month === 1 ? 'Last Month' : 'Current Month'}
                </div>
              ))}
          </div>
          {/* Hours Row */}
          <div className="flex justify-between w-full pt-2">
            {filterData &&
              filterData.Values &&
              filterData.Months.length > 0 &&
              filterData.Values.map((val, index) => (
                <div key={`I-${index}`} className="flex-1 text-center text-black text-lg font-bold">
                  {val}
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardMonthData;
